import React from 'react';

const defaultValue = {
  isMobile: false,
  isTablet: false,
};

export const DeviceDetectContext = React.createContext(defaultValue);

export default DeviceDetectContext;
